import React from 'react';
import '../StyleSheets/GlobalSnapshot.css';
import GraphDataItem from './GraphDataItem';
import { gsap } from 'gsap';
import MaterialIcon from 'material-icons-react';
import FilterSelect from './FilterSelect';

const globalSnapshotModes = ["GENERAL_POLICY","FINANCIAL_AID"];

export default class GlobalSnapshot extends React.Component {

    constructor(props) {
        super(props);


        const allData = props.coronaData;

        const dailyMeasuresOptions = [];

        props.appSettings.dailyMeasuresKeys.forEach( m=>{

            if( m !== "average_temp" && m !== "exchange_rate" ) {

                dailyMeasuresOptions.push( {key: m, title: allData.hebrew_legend[ m ].title } );
            }

        });

        const countryConstantsOptions = [];

        countryConstantsOptions.push( {key: "population", title: "אוכלוסייה"} );
        countryConstantsOptions.push( {key: "over_65_percentage", title: "שיעור גילאי 65+"} );

        const policyEventsCategoryOptions = [];
        const initActivePolicies = [];
        props.appSettings.policyEventsKeys.forEach( (p,i) => {

            policyEventsCategoryOptions.push( {key: p, title: allData.hebrew_legend[ p ].title } );
            initActivePolicies.push(true);

        });

        const economicPoliciesOptions = [];
        const initActiveEconomicPolicies = [];
        props.appSettings.economicPolicyKeys.forEach( p => {
            if (allData.hebrew_legend[ p ]) {
                economicPoliciesOptions.push( {key: p, title: allData.hebrew_legend[ p ].title } );
            initActiveEconomicPolicies.push(true);
            }
            

        });

        const countries = Object.keys( allData.data ).sort( (a,b) => {if(a==="ישראל") return -1; else return 1;});

        
        this.state = {
            covidData: allData,
            countries: countries,  
            policyEventsCategoryOptions,
            currentActivePolicies: initActivePolicies, 
            economicPoliciesOptions,
            currentActiveEconomicPolicies: initActiveEconomicPolicies,   
            dailyMeasuresOptions,      
            countryConstantsOptions,
            mode: globalSnapshotModes[0],
            isFinancialAid: false,
            activeCountries: countries.map( c=>c = false),
            setAllActive: false,
            hideSideData: false,
        }
    }

    updateShowIndex(index, value) {
        const { activeCountries } = this.state
        const newActiveCountries = []
        for(let i=0;i<Math.max(activeCountries.length, index + 1);i++) {
            if(i === index) {
                newActiveCountries[i] = value
            } else {
                newActiveCountries[i] = activeCountries[ i ]
            }
        }
        // console.log(newActiveCountries)
        this.setState({
            activeCountries: newActiveCountries
        })
    }

    
    getDailyData(inx, cuntry, fieldKey) {
        const allData = this.props.coronaData;
        const list = allData.data[cuntry][fieldKey]
        
        if(!list) return null
        const lastItem = list[list.length - 1]

        return {
            title: this.state.dailyMeasuresOptions[inx].title,
            value: lastItem.v
        }
    }

    getConstantData(inx, country, fieldKey) {
        const allData = this.props.coronaData;
        let field = allData.data[country]["constant"][fieldKey]

        if(!field) return null

        if(fieldKey === "over_65_percentage" ) field = (field * 100).toFixed(2) + "%";

        return {
            title: this.state.countryConstantsOptions[inx].title,
            value: field
        }
    }

    getPolicyTextEvent(inx, cuntry, fieldKey) {
        
        const allData = this.props.coronaData;
        const list = allData.data[cuntry][fieldKey]
        if(!list) return null
        const lastItem = list[list.length - 1]

        return {
            title: this.state.policyEventsCategoryOptions[inx].title,
            severity: lastItem.v,
            value: lastItem.cur_status
        }
    }

    getEconomicPolicyTextEvent(inx, cuntry, fieldKey) {
        
        const allData = this.props.coronaData;
        const list = allData.data[cuntry][fieldKey]
        if(!list) return null
        const lastItem = list[list.length - 1]

        return {
            title: this.state.economicPoliciesOptions[inx].title,
            binary: lastItem.v2,
            value: lastItem.cur_status
        }
    }

    render() {

        const {
            activeCountries, 
            dailyMeasuresOptions, 
            policyEventsCategoryOptions, 
            countries, 
            countryConstantsOptions,
            mode,
            currentActivePolicies,
            economicPoliciesOptions,
            currentActiveEconomicPolicies,
            setAllActive,
            hideSideData,
        } = this.state
        
        // const dailyMeasuresOptions = JSON.parse(JSON.stringify(this.state.dailyMeasuresOptions)).reverse();
        // const policyEventsCategoryOptions = JSON.parse(JSON.stringify(this.state.policyEventsCategoryOptions)).reverse();
        
        const countriesToShow = []

        for(let i=0;i<countries.length;i++) {
            activeCountries[i] && countriesToShow.push(countries[i])
            // true && countriesToShow.push(countries[i])
        }
        
        return <div>
                <div id="globalSnapshotOptionsBar">
                    <ToolbarButton 
                        tooltipTitle="פריסת כל המדינות" 
                        iconName="view_day" 
                        displayName=""
                        isActive={setAllActive}
                        onClick={()=> {
                            const newActiveCountries = activeCountries.map( c => c=!setAllActive);
                            this.setState({setAllActive: !setAllActive, activeCountries: newActiveCountries});
                        } }
                    />
                    <ToolbarButton 
                        tooltipTitle="הצגת מדיניות כללית" 
                        iconName="report" 
                        displayName="מדיניות"
                        isActive={mode === globalSnapshotModes[0]}
                        onClick={()=> {
                            const targetmode = mode === globalSnapshotModes[0] ? 1 : 0;
                            this.setState({mode: globalSnapshotModes[targetmode]});
                        } }
                    />

                    <ToolbarButton 
                        tooltipTitle="הצגת סיוע כלכלי"
                        iconName="monetization_on" 
                        displayName="סיוע"
                        isActive={mode === globalSnapshotModes[1]}
                        onClick={()=> {
                            const targetmode = mode === globalSnapshotModes[0] ? 1 : 0;
                            this.setState({mode: globalSnapshotModes[targetmode]});
                        } }
                    />
                    <div style={{position:"absolute", left: "20px"}}>
                        <ToolbarButton 
                            tooltipTitle="הסתרת נתונים מספריים"
                            iconName="" 
                            displayName={hideSideData ? "הצגת נתונים" : "הסתרת נתונים"}
                            isActive={true}
                            onClick={()=> {
                                this.setState({hideSideData: !hideSideData});
                            } }
                        />
                    </div>

                    { mode === globalSnapshotModes[0] ? 
                    <FilterSelect
                        key="policyFilterComp"
                        title={"סינון קטגוריות מדיניות"}
                        theme="dark" 
                        list={policyEventsCategoryOptions} 
                        position={{t: '24px', r: '320px'}}
                        activeItems={ currentActivePolicies }
                        bgColor="#efefef"
                        onItemSelect={ list => this.setState( {currentActivePolicies: list}) }
                    /> :
                    <FilterSelect
                        key="economicPolicyFilterComp"
                        title={"סינון תחומי סיוע"}
                        theme="dark" 
                        list={economicPoliciesOptions } 
                        position={{t: '24px', r: '320px'}}
                        activeItems={ currentActiveEconomicPolicies }
                        bgColor="#efefef"
                        onItemSelect={ list => this.setState( {currentActiveEconomicPolicies: list}) }
                    /> }
                </div>
                <div id="globalSnapshotCont">
                    { countries.map( (c,i) => {
                        return <CountrySnapshotTable key={i} countryName={c} 
                            index={i}
                            isOpen={activeCountries[i]}
                            mode={mode}
                            hideSideData={hideSideData}
                            color={this.props.appSettings.colors[4 + i]} 
                            onSelfCollapse={()=>{
                                const newActiveCountries = activeCountries;
                                newActiveCountries[ i ] = !activeCountries[i];
                                this.setState( {activeCountries: newActiveCountries });
                            }}

                            policies={ policyEventsCategoryOptions.map( (p,i) => this.getPolicyTextEvent( i,c,p.key ) ) } 
                            activePolicies={currentActivePolicies}

                            economicPolicies={ economicPoliciesOptions.map( (p,i) => this.getEconomicPolicyTextEvent( i,c,p.key ) ) }
                            activeEconomicPolicies={currentActiveEconomicPolicies}

                            dailies={ dailyMeasuresOptions.map( (d,i) => this.getDailyData( i, c, d.key ) ) } 
                            constants={ countryConstantsOptions.map( (_,i) => this.getConstantData( i, c, _.key ) )}
                        />
                    }) }

                </div>

        </div>
        
    }

}

function ToolbarButton(props) {

    const { iconName, tooltipTitle, displayName, isActive, onClick } = props;

    return (
        <div className="globalSnapshotModeButton" title={tooltipTitle}
            style={{
                opacity: isActive ? 1 : 0.3, 
            }}
            onClick={onClick}>
            <MaterialIcon icon={iconName} size = {30} color={ 'black' }/>
            <span style={{paddingRight: displayName !== "" ? "4px" : "0px"}}>{displayName}</span>
        </div>
    )
}



class CountrySnapshotTable extends React.Component {

    constructor(props) {
        super(props);

        this.mainContRef = React.createRef();

        this.cptTableRef = React.createRef();

        this.state = {
            mounted: false,
        }

    }

    componentDidMount() {

        this.collapsedHeight = 64;
        
        this.toggleOpen = ( shouldOpen ) =>{
            const h = this.mainContRef.current.scrollHeight;

            gsap.to( 
                this.mainContRef.current, 
                { height: shouldOpen ? h : this.collapsedHeight, duration: 0.5, ease: "power3.out" }
            );
        }

        gsap.from( this.mainContRef.current, { y:200, opacity:0, duration: 0.4, delay: this.props.index * 0.02, ease:"power3.out" } );

        this.setState({mounted:true});

    }


    render() {
        const { countryName, 
            color, 
            policies, 
            activePolicies, 
            dailies, 
            constants,
            mode,
            economicPolicies,
            activeEconomicPolicies,
            isOpen,
            onSelfCollapse,
            hideSideData
        } = this.props;
        const { mounted } = this.state;


        const currentActivePolicies = JSON.stringify( mode === globalSnapshotModes[0] ? activePolicies : activeEconomicPolicies );

        if( mounted && ( currentActivePolicies !== this.lastActivePolicies || mode !== this.lastMode ) ) {

            if( isOpen ) { 
                this.mainContRef.current.style.height = "auto"; 
            }

            gsap.fromTo( this.cptTableRef.current, { opacity:0 }, { opacity:1, duration: 0.4, delay: this.props.index * 0.02, ease:"power3.out" } );
        }
        
        this.lastActivePolicies = currentActivePolicies;
        this.lastMode = mode;
        
        if( mounted && this.lastIsOpen !== isOpen ) {
            this.toggleOpen( isOpen );
            this.lastIsOpen = isOpen;
        }

        return <div ref={this.mainContRef} className={ "countrySnapshotTableCont"}>
            <div className="countryTableContToggle">
                <GraphDataItem 
                    title={countryName} 
                    color={color} 
                    isActive={ isOpen } 
                    onToggle={ a=> {
                        onSelfCollapse();
                        // this.toggleOpen( collapsed );
                        // this.setState({collapsed: !collapsed});
                    }}
                    inActiveOpacity={0.9}
                />
            </div>
            <div className="countryPolicyTableCont" style={{opacity: isOpen ? 1 : 0.9}}>
                <table className="cptTable" ref={this.cptTableRef}>
                    <tbody>
                        { mode === globalSnapshotModes[0] ? 
                            policies.map( (p,i) => {
                                if( !activePolicies[i] || p === null ) return null
                                const borderBottom = i === policies.length-1 ? "none" : "";
                                const severityColor = global.getSeverityColor( p.severity );
                                const severitySpanStyle = {
                                    backgroundColor: severityColor, 
                                    width: "40px", height: "30px", 
                                    margin: "6px 10px",
                                    borderRadius: "4px",
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }
                                return <tr key={"cptTable_"+i}>
                                    <th className="policyCategoryTitle" style={{borderBottom:borderBottom}} valign="top">{p.title}</th>
                                    <th className="policyValueCell" style={{borderBottom:borderBottom}} valign="top"> 
                                        <div style={severitySpanStyle}>{p.severity}</div> 
                                    </th>
                                    <th style={{borderBottom:borderBottom}} valign="top">{p.value}</th>
                                </tr>
                            } ) 
                            :
                            economicPolicies.map( (p,i) => {
                                if( !activeEconomicPolicies[i] || p === null ) return null
                                const borderBottom = i === economicPolicies.length-1 ? "none" : "";
                                const binayStyle = {
                                    backgroundColor: p.binary ? "#306B53" : "#E03636", 
                                    color: "white",
                                    width: "40px", height: "30px", 
                                    margin: "6px 10px",
                                    borderRadius: "4px",
                                    display: "flex", alignItems: "center", justifyContent: "center"
                                }

                                let paragraphs = [];
                                if( p.value !== undefined ) {
                                    paragraphs = p.value.split( "* " );
                                }
                                // console.log( paragraphs );
                                
                                return <tr key={"cptTable_"+i}>
                                    <th className="policyCategoryTitle" style={{borderBottom:borderBottom}} valign="top">{p.title}</th>
                                    <th className="policyValueCell" style={{borderBottom:borderBottom}} valign="top">
                                        <div style={binayStyle}> { p.binary ? "+" : "-" } </div>
                                    </th>
                                    <th style={{borderBottom:borderBottom}} valign="top">
                                        { 
                                            paragraphs.map( (par,j) => {
                                                
                                                if( par === "" ) return null;
                                                return <p key={"ept_"+j} className="ept_paragraph">{par}</p>

                                            }
                                        )}
                                    </th>
                                </tr>
                            })
                        
                        }
                    </tbody>
                </table>
                { !isOpen ? <div className="countrySnapshotBottomFade"/> : null }
            </div>
            { !hideSideData ? <div className="countryDailyDataTableCont" style={{backgroundColor: color + "55", opacity: isOpen? 1:0.9}}>
                <table className="cddTable">
                    <tbody>
                        { [ dailies.map( (d,i) => {
                            if( d === null ) return null
                            // const s = {borderBottom: i === dailies.length-1 ? "none" : "" }
                            return <tr key={"cddTable"+i}>
                                <th className="dailyDataTitle">{d.title}</th>
                                <th className="dailyDataValue">{d.value.toLocaleString('he-IL')}</th>
                            </tr>
                        } ),
                        
                            constants.map( (c,i) => {
                                if( c === null ) return null
                                const s = {borderBottom: i === constants.length-1 ? "none" : "" }

                                return <tr key={"cdcTable"+i}>
                                    <th className="dailyDataTitle" style={s}>{c.title}</th>
                                    <th className="dailyDataValue" style={s} >{c.value.toLocaleString('he-IL')}</th>
                                </tr>
                            } )
                        ] }
                    </tbody>
                </table>
            </div>
            : null }
            
        </div>
    }
}